<div class="cs_header">
  <a href="https://rundna.com/" target="_blank"><img class="cs_logo" src="../../../../assets/img/gaitreport/logo.png" alt="logo" /></a>
</div>

<div class="pt-5">
  <router-outlet></router-outlet>
</div>
